<p *ngIf="tenant_error" class="alert alert-danger" role="alert">{{tenant_error}}</p>
<div *ngIf="player?.is_suspended == 1" class="alert alert-danger" role="alert"><strong>Account suspended.</strong> Top-up, withdrawal and agent actions are unavailable. <button type="button" class="btn btn-outline-danger btn-sm ms-2" (click)="resetPlayer()">New search</button></div>
<fieldset class="border-0 p-0 m-0 w-100" [disabled]="player?.is_suspended == 1" [attr.inert]="player?.is_suspended == 1 ? '' : null">
<fieldset [disabled]="is_loading_function" [attr.inert]="is_loading_function ? '' : null" class="border-0 p-0 m-0 w-100">
<div class="row mb-3" *ngIf="tenant_companies.length > 1">
    <div class="col-12 col-lg-8"><div class="alert alert-info mb-0">
        <strong>{{tenant_grouped ? tenant_report_name + " consolidated companies" : "All permitted companies"}}</strong>
        <span class="ms-2">Search across {{tenant_companies.length}} companies {{tenant_grouped ? "in this consolidated group" : "in your company selector"}}. Transactions use the selected player's company.</span>
    </div></div>
</div>

<!-- Search Player -->
<div class="row" *ngIf="!data.player_uuid">
    <div class="col-12 col-md-12 col-lg-8">
        <div class="page-section">
            <div class="page-section-header">
                <h2 class="page-section-title">Search Player (Manual/手动)</h2>
            </div>
            <div class="page-section-filters">
                <input type="text" class="form-control form-control-sm flex-fill" style="max-width:none;"
                    placeholder="Enter Player Code / Mobile / Name" #search="ngModel" [(ngModel)]="player_search" />
                <button *ngIf="!isCrossTenant()" (click)="addPlayer()" class="btn btn-primary btn-sm">+ Player</button>
                <button *ngIf="!isCrossTenant()" class="btn btn-outline-primary btn-sm" (click)="getUnknownPayment()">+ Unknown Payment</button>
            </div>
            <div *ngIf="is_searching_player" class="p-3">
                <p class="text-muted mb-0" style="font-style: italic;">Searching Player ...</p>
            </div>
            <div class="page-section-body" *ngIf="!is_searching_player && players.length > 0 && !data.player_uuid">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Company</th>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let player of players">
                            <td class="align-middle"><span class="badge bg-info">{{player.operation_company_name}}</span></td>
                            <td class="align-middle">{{player.code}} <span *ngIf="player.is_suspended == 1" class="badge bg-danger">Suspended</span></td>
                            <td class="align-middle">{{player.name}}</td>
                            <td class="align-middle">{{player.mobile}}</td>
                            <td class="text-end"><button class="btn btn-sm btn-outline-primary"
                                    (click)="selectPlayer(player)"><small>Select</small></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Player Selected -->
<ng-container *ngIf="data.player_uuid">

    <!-- Player Detail + Bank Summary Row -->
    <div class="row mb-3">
        <div class="col-md-4 col-lg-3 col-12 mb-3 mb-md-0">
            <div class="page-section mb-0">
                <div class="page-section-header">
                    <h2 class="page-section-title">Player Detail</h2>
                    <div class="page-section-actions">
                        <button class="btn btn-sm btn-warning" (click)="resetPlayer()">New Search</button>
                        <button *ngIf="!isCrossTenant()" class="btn btn-sm btn-outline-light" (click)="addPlayer(player)">Edit</button>
                        <button *ngIf="effectiveReportCompanyUuid || !isCrossTenant()" class="btn btn-sm btn-outline-light" (click)="playerProfit()">Profit</button>
                        <button *ngIf="effectiveReportCompanyUuid" class="btn btn-sm btn-outline-light" (click)="getDaily()">Copy Report</button>
                        <button *ngIf="!isCrossTenant()" class="btn btn-sm btn-outline-light" (click)="luckyDraw()">L.Draw</button>
                        <button *ngIf="!isCrossTenant()" class="btn btn-sm btn-outline-light" (click)="commissionModal()">Comm</button>
                    </div>
                </div>
                <div class="page-section-form">
                    <div class="d-flex align-items-center gap-2 mb-3 pb-3" style="border-bottom: 1px solid #e5e7eb;">
                        <div>
                            <div class="fw-bold" style="font-size: 15px;">{{player.name}}</div>
                            <div class="text-muted" style="font-size: 12px;">{{player.code}}</div>
                            <div class="mt-1" *ngIf="operationCompanyName">
                                <span class="badge bg-info">Company: {{operationCompanyName}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label" style="font-size: 12px;">Game<em>*</em></label>
                        <ng-select class="flex-fill" bindLabel="title" bindValue="id" [items]="games" [clearable]="true"
                            [placeholder]="'Select Game'" (change)="getPlayerGameID()" [(ngModel)]="data.game_id">
                        </ng-select>
                    </div>

                    <div class="mb-3" *ngIf="data.player_uuid && data.game_id">
                        <div class="d-flex flex-row justify-content-between align-items-center mb-1">
                            <label class="form-label mb-0" style="font-size: 12px;">Player Game ID <em>*</em></label>
                            <button class="btn btn-sm p-0 text-primary" style="font-size: 11px;" (click)="copyUsername()"
                                *ngIf="data.player_game_id">COPY</button>
                        </div>
                        <ng-select #selectPlayerGameID bindLabel="username" bindValue="id"
                            [loading]="is_loading_player_game_id" loadingText='Loading...' [items]="player_ids"
                            [clearable]="true" (change)="changePlayerGameID()" [placeholder]="'Select Player ID'"
                            [(ngModel)]="data.player_game_id">
                            <ng-template ng-option-tmp let-item="item">
                                <div>{{item.username}}</div>
                                <div *ngIf="item.password">{{item.password}}</div>
                            </ng-template>
                            <ng-template ng-option-label let-item="item">
                                <div><strong>{{item.username}}</strong> <span>({{item.password}})</span></div>
                            </ng-template>
                            <ng-template ng-footer-tmp>
                                <span (click)="addNewPlayerIDForm()">Create New </span>
                            </ng-template>
                        </ng-select>
                        <button class="btn btn-sm btn-outline-danger mt-1" (click)="removePlayerID()" *ngIf="player_ids.length > 0"
                            style="font-size: 11px;">Remove ID</button>
                    </div>

                    <div class="d-flex flex-column gap-2"
                        *ngIf="data.player_uuid && data.game_id && data.player_game_id && !is_loading_player_game_id">
                        <button class="btn btn-dark btn-sm w-100" [disabled]="is_loading_function"
                            (click)="addNewPlayerIDForm()">Update Player Game ID</button>
                        <button class="btn btn-outline-dark btn-sm w-100" [disabled]="is_loading_function"
                            (click)="copy()">Copy Details</button>
                        <button *ngIf="effectiveReportCompanyUuid || !isCrossTenant()" class="btn btn-outline-primary btn-sm w-100" (click)="getDaily()">Daily</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-8 col-lg-9 col-12">
            <div class="row">
                <div class="col-lg-5 col-12 mb-3 mb-lg-0">
                    <div class="page-section mb-0">
                        <div class="page-section-header">
                            <h2 class="page-section-title">Bank Summary</h2>
                        </div>
                        <div class="page-section-body">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Bank Name</th>
                                        <th class="text-end">Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let bank of banks">
                                        <th>{{bank.title}}</th>
                                        <td class="text-end">{{bank.balance | number : '1.2-2'}}</td>
                                    </tr>
                                    <tr *ngIf="!banks || banks.length === 0">
                                        <td colspan="2" class="text-center text-muted py-3" style="font-style: italic;">No banks found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Copy Alert -->
    <div class="alert alert-success d-flex align-items-center gap-3 py-2" *ngIf="is_copy">
        <span class="fw-bold">Player Detail Copied!</span>
        <button class="btn btn-dark btn-sm" [disabled]="is_loading_function" (click)="copy()">Copy Again</button>
    </div>

    <!-- Action Cards: Topup / Withdraw / Transfer -->
    <ng-container *ngIf="data.game_id && data.player_game_id && !is_loading_player_game_id">
        <div class="row mb-3">
            <div class="col-md-4 col-12 mb-3 mb-md-0" *ngIf="can('manual-wallet-topup')">
                <div class="page-section mb-0">
                    <div class="page-section-header">
                        <h2 class="page-section-title">Topup</h2>
                    </div>
                    <div class="page-section-form">
                        <div class="mb-3">
                            <div class="form-check">
                                <input id="topup_only" class="form-check-input" type="checkbox" value="1"
                                    [(ngModel)]="data.topup_only" (change)="topupOnlyChange()" />
                                <label for="topup_only" class="form-check-label">Topup Point Only.</label>
                            </div>
                        </div>
                        <hr />
                        <div class="mb-3" *ngIf="!data.topup_only">
                            <label class="form-label">Amount to Topup</label>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="data.amount"
                                (input)="topupValueChange()" />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Bonus</label>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="data.bonus" />
                        </div>
                        <p class="text-danger" style="font-size: 12px;" *ngIf="data.amount && data.bonus">Total Game Point Topup : {{data.amount + data.bonus}}</p>
                        <hr />

                        <ng-container *ngIf="!data.topup_only">
                            <div class="mb-3" *ngIf="player.referral_id && referral_rate > 0">
                                <label class="form-label">Referral Commission</label>
                                <input type="number" class="form-control form-control-sm"
                                    [(ngModel)]="data.referral_commission" readonly="readonly" />
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Point +/-</label>
                                <input type="number" class="form-control form-control-sm" [(ngModel)]="data.point"
                                    [readonly]="setting.credit_calculation_method == 'auto' && setting.credit_calculation_rate" />
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Bank In To Account — {{operationCompanyName}}</label>
                                <ng-select #select bindLabel="title" bindValue="id" [items]="depositBanks" [clearable]="true"
                                    [placeholder]="'Select Bank'" [(ngModel)]="data.deposit_bank" appendTo="body" [dropdownPosition]="'auto'">
                                    <ng-template ng-label-tmp let-item="item">
                                        <div>{{item.title}} ({{item.balance}})</div>
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item">
                                        <div>{{item.title}} ({{item.balance}})</div>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </ng-container>
                        <button class="btn btn-success w-100 btn-sm" (click)="topup()" type="submit"
                            [disabled]="is_loading_function">Topup</button>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-12 mb-3 mb-md-0" *ngIf="can('manual-wallet-withdraw')">
                <div class="page-section mb-0">
                    <div class="page-section-header">
                        <h2 class="page-section-title">Withdraw</h2>
                    </div>
                    <div class="page-section-form">
                        <div class="mb-3">
                            <label class="form-label">Amount to Withdraw</label>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="data.withdraw"
                                (input)="withdrawValueChange()" />
                        </div>
                        <hr />
                        <div class="mb-3">
                            <div class="form-check">
                                <input id="withdraw_only" class="form-check-input" type="checkbox" value="1"
                                    [(ngModel)]="data.withdraw_only" />
                                <label for="withdraw_only" class="form-check-label">Withdraw Point Only.</label>
                            </div>
                        </div>

                        <div class="mb-3" *ngIf="!data.withdraw_only">
                            <label class="form-label">Tips</label>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="data.withdraw_tips" />
                        </div>

                        <div class="mb-3" *ngIf="!data.withdraw_only">
                            <label class="form-label">Point +/-</label>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="data.withdraw_point"
                                [readonly]="setting.credit_calculation_method == 'auto'" />
                        </div>

                        <div class="mb-3"
                            *ngIf="!data.withdraw_only && (setting.hide_actual_pay_to_customer == 'false' || !setting.hide_actual_pay_to_customer)">
                            <label class="form-label">Actual Pay to Customer Bank</label>
                            <input type="number" class="form-control form-control-sm"
                                [(ngModel)]="data.actual_pay_to_bank" />
                        </div>

                        <div class="mb-3" *ngIf="!data.withdraw_only">
                            <label class="form-label">Payout From — {{operationCompanyName}}</label>
                            <ng-select #select bindLabel="title" bindValue="id" [items]="withdrawBanks" [clearable]="true"
                                [placeholder]="'Select Bank'" [(ngModel)]="data.withdraw_from_account" appendTo="body" [dropdownPosition]="'auto'">
                                <ng-template ng-label-tmp let-item="item">
                                    <div>{{item.title}} ({{item.balance}})</div>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <div>{{item.title}} ({{item.balance}})</div>
                                </ng-template>
                            </ng-select>
                        </div>

                        <div class="mb-3" *ngIf="!data.withdraw_only">
                            <div class="d-flex flex-row justify-content-between align-items-start">
                                <label class="form-label">Payout To Account</label>
                                <button class="btn btn-sm p-0 text-primary" style="font-size: 11px;" (click)="copyAccount()"
                                    *ngIf="data.withdraw_to_account">COPY</button>
                            </div>
                            <ng-select #payout bindLabel="bank" bindValue="id" [items]="player_banks" [clearable]="true"
                                [placeholder]="'Select Account For Payout'" [(ngModel)]="data.withdraw_to_account">
                                <ng-template ng-label-tmp let-item="item">
                                    <div>{{data.withdraw_to_account != "new" ? (item.bank + ' - ' + item.account) : "NEW"}}</div>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <div>{{item.bank}} - {{item.account}}</div>
                                </ng-template>
                                <ng-template ng-footer-tmp>
                                    <span (click)="createNewAccount()">Create New </span>
                                </ng-template>
                            </ng-select>
                            <div class="input-group mt-3"
                                *ngIf="setting.enabled_finance_charge && setting.finance_charge_rate">
                                <div class="input-group-append flex-fill">
                                    <div class="input-group-text">
                                        <label class="me-2" for="finance_charge">Finance Charge</label>
                                        <select [(ngModel)]="data.finance_charge" #fc="ngModel" id="finance_charge"
                                            name="finance_charge" (change)="fcRateChange()" required>
                                            <option [value]="true">YES</option>
                                            <option [value]="false">No</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3" style="font-size: 12px;"
                                *ngIf="setting.enabled_finance_charge && setting.finance_charge_rate && data.withdraw && data.finance_charge === 'true'">
                                Final Bank Transaction:<br />{{data.actual_pay_to_bank ?? 0}} +
                                {{setting.finance_charge_rate}} = <span class="text-danger fw-bolder">{{(data.actual_pay_to_bank ?? 0) +
                                    setting.finance_charge_rate}}</span>
                            </div>
                        </div>

                        <ng-container *ngIf="!data.withdraw_only && data.withdraw_to_account == 'new'">
                            <div class="mb-3">
                                <label class="form-label">Bank Name</label>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="data.withdraw_bank" />
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Account Number</label>
                                <input type="text" class="form-control form-control-sm" [(ngModel)]="data.withdraw_account_no" />
                            </div>
                        </ng-container>
                        <button class="btn btn-success w-100 btn-sm" (click)="withdraw()" type="submit"
                            [disabled]="is_loading_function">Withdraw</button>
                    </div>
                </div>

                <!-- Transfer Game Credit -->
                <div class="page-section mt-3 mb-0" *ngIf="can('manual-wallet-topup') && can('manual-wallet-withdraw')">
                    <div class="page-section-header">
                        <h2 class="page-section-title">Transfer Game Credit</h2>
                    </div>
                    <div class="page-section-form">
                        <div class="mb-3">
                            <label class="form-label">Game<em>*</em></label>
                            <ng-select class="flex-fill" bindLabel="title" bindValue="id" [items]="transfer_games"
                                [clearable]="true" [placeholder]="'Select Game'" (change)="getTransferPlayerGameID()"
                                [(ngModel)]="data.transfer_game_id">
                            </ng-select>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Player Game ID <em>*</em></label>
                            <ng-select #selectPlayerGameID bindLabel="username" bindValue="id"
                                [loading]="is_loading_player_game_id" loadingText='Loading...' [items]="transfer_player_ids"
                                [clearable]="true" [placeholder]="'Select Player ID'"
                                [(ngModel)]="data.transfer_player_game_id">
                                <ng-template ng-option-tmp let-item="item">
                                    <div [ngClass]="{'bg-black text-light small px-2': item.status != 1}">{{item.username}}</div>
                                    <div [ngClass]="{'bg-black text-light small px-2': item.status != 1}"
                                        *ngIf="item.password">{{item.password}}</div>
                                </ng-template>
                                <ng-template ng-option-label let-item="item">
                                    <div><strong>{{item.username}}</strong> <span>({{item.password}})</span></div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Transfer Amount</label>
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="data.transfer" />
                        </div>
                        <button class="btn btn-success w-100 btn-sm" (click)="transfer()" type="submit"
                            [disabled]="is_loading_function">Transfer</button>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <app-player-transaction-history [all]="true" [setPlaterUUID]="data.player_uuid" [request_context]="tenantRequestContext"
                    [visible_tabs]="['bank', 'game', 'wallet', 'other']" #th></app-player-transaction-history>
            </div>
        </div>
    </ng-container>

    <!-- Transaction History (when player selected but no game/ID yet) -->
    <div class="row" *ngIf="!data.game_id || !data.player_game_id || is_loading_player_game_id">
        <div class="col-12">
            <app-player-transaction-history [all]="true" [setPlaterUUID]="data.player_uuid" [request_context]="tenantRequestContext"
                [visible_tabs]="['bank', 'game', 'wallet', 'other']" #th></app-player-transaction-history>
        </div>
    </div>

</ng-container>

</fieldset>

</fieldset>
